var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"foot clearfix"},[_c('div',{staticClass:"back"},[_c('i',{on:{"click":_vm.back}})]),_vm._v(" "),_c('div',{staticClass:"reload"},[_c('i',{on:{"click":_vm.reload}})]),_vm._v(" "),_c('div',{staticClass:"home"},[_c('i',{on:{"click":_vm.home}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c280921","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/public/foot.vue
// module id = vpVJ
// module chunks = 0